import React, { useCallback, useState, useEffect } from "react";

export default function useAsync(callback, dependencies = []) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [value, setValue] = useState();
  const [reFetch, setReFetch] = useState(1);

  // console.log({ reFetch });
  const callbackMemoized = useCallback(() => {
    setLoading(true);
    setError(undefined);
    // setValue(undefined);
    callback()
      .then(setValue)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [...dependencies, reFetch]);

  useEffect(() => {
    callbackMemoized();
  }, [callbackMemoized]);

  return {
    loading,
    error,
    value,
    setValue,
    reFetch,
    setReFetch: () => setReFetch((prev) => prev + 1),
  };
}
